import { Container } from 'react-bootstrap';
import '../style/sectionprovide.css';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

export default function Friendly() {
  const navigate = useNavigate();
const [activeLink, setActiveLink] = useState(""); // حالة لتخزين الرابط النشط

const handleClick = (e, path) => {
  e.preventDefault(); // منع إعادة تحميل الصفحة
  setActiveLink(path); // تحديث المسار النشط
  navigate(path); // التنقل باستخدام React Router
};
  return (
    <div className='Friendly'>
      <Container>
        <div className='inside'>
          <div className='Friendly-left'>
            <h4>Erschwingliche Reinigungslösungen</h4>
            <h2>
              Hochwertige und freundliche <br /> Dienstleistungen zu fairen
              Preisen
            </h2>
            <p>
              Wir bieten umfassende Reinigungsdienstleistungen, die auf Ihre
              Bedürfnisse zugeschnitten sind. Von der Reinigung von Wohngebäuden
            </p>
            <button  onClick={(e) => handleClick(e, "/contact")} className='f-btn'>Ein Angebot erhalten</button>
          </div>
          <div className='Friendly-right'>
            <div className='f-r-box'>
            <img className='second' src='/images/Image (1).png' alt='' />
              <img className='frist' src='/images/Image (2).png' alt='' />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
